import styled from 'styled-components'

import { ReactComponent as Arrows } from './assets/arrowsIcon.svg'
import { ReactComponent as LeftArrow } from './assets/leftIcon.svg'
import { ReactComponent as RightArrow } from './assets/rightIcon.svg'

import { CHANNEL_LIST_CONTROL_WIDTH } from '../ChannelListControl/elements'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: calc(100% - ${CHANNEL_LIST_CONTROL_WIDTH}rem);
  height: 98rem;
  position: absolute;
  bottom: 0;
  right: 0;
  background-color: rgba(29, 29, 29, 0.8);
  z-index: 1;
`

export const Prompt = styled.div`
  display: flex;
  align-items: center;
  height: 45rem;
  font-weight: 700;
  font-size: 28rem;
  color: #f8f4f4;
  margin-right: 49rem;
`

export const ArrowsIcon = styled(Arrows)`
  width: 18rem;
  height: 41rem;
  margin-right: 10rem;
`

export const LeftArrowIcon = styled(LeftArrow)`
  width: 32rem;
  height: 41rem;
  margin-right: 10rem;
`

export const RightArrowIcon = styled(RightArrow)`
  width: 32rem;
  height: 41rem;
  margin-right: 10rem;
`
